import { render } from "./SelfServiceWindowSettings.vue?vue&type=template&id=4aa6614c"
import script from "./SelfServiceWindowSettings.vue?vue&type=script&lang=js"
export * from "./SelfServiceWindowSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__